import { ClipboardList } from '@styled-icons/fa-solid/ClipboardList';

export const QUESTIONNAIRE_TEMPLATES_MENU_ITEMS = [
  {
    text: 'Questionnaire Templates',
    url: '/questionnaire-templates',
    icon: ClipboardList,
    overViewPage: {
      text: 'Questionnaire Template',
      url: '/questionnaire-templates/:templateId'
    }
  }
];
